
			if (!shouldLazyLoadPlayground) {
				import('./src/main');
			}
		